import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate} from 'react-router-dom';

import {
  Box,
  Container,
  Typography,
  Button,
  IconButton,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  MenuItem,
  AppBar,
  Toolbar,
  InputAdornment,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Alert,
  Select,
  FormControl,
  InputLabel,
  Chip,
  
  } from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  ExpandMore as ExpandMoreIcon, // Agregado
  EventNote as EventNoteIcon,    // Agregado
  ArrowBack as ArrowBackIcon,
  Pets as PetsIcon,
  Directions as DirectionsIcon,
  BusAlert  as BusAlertIcon, 
} from '@mui/icons-material';
import api from '../api/api';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LogisticaDomicilioModal from './LogisticaDomicilioModal'; // Ajusta la ruta si es necesario
import UpdateIcon from '@mui/icons-material/Update';
import dayjs from 'dayjs';

const ESTADOS_TRANSPORTE = [
  'PENDIENTE', 'CONFIRMADO', 'EN_CAMINO_RECOGIDA', 'RECOGIDO',
  'EN_CLINICA', 'SERVICIO_COMPLETADO', 'EN_CAMINO_ENTREGA',
  'ENTREGADO', 'CANCELADO', 'NO_ASISTIO'
];

//const ESTADOS_FACTURA = [
  //'PENDIENTE', 'FACTURADO', 'ANULADA', 'PAGO_PARCIAL', 'PAGADO'
//];

const LogisticaDomicilio = () => {
  const navigate = useNavigate();
  const [clienteMap, setClienteMap] = useState({});
  const [domicilios, setDomicilios] = useState([]);
  const [originalDomicilios, setOriginalDomicilios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [pacientesCliente, setPacientesCliente] = useState([]);
  const [razas, setRazas] = useState([]);
  const [esRecurrente, setEsRecurrente] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedDomicilio, setSelectedDomicilio] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [fechaFiltro, setFechaFiltro] = useState(dayjs());
  const [estadoFiltro, setEstadoFiltro] = useState('');
  const [sucursalFiltro, setSucursalFiltro] = useState('');
  const [sugerencias, setSugerencias] = useState([]);
  const initialFormData = {
    id_cliente: '',
    id_paciente: '',
    id_config: '',
    id_sucursal: '',
    fecha_servicio: dayjs().format('YYYY-MM-DD'),
    hora_recogida_aprox: '',
    hora_entrega_aprox: '',
    hoja_servicio: '',
    servicio_realizado: '',
    modificaciones: '',
    etiquetas: '',
    estado_transporte: 'PENDIENTE',
    numero_factura: '',
    fecha_factura: null,
    estado_factura: 'PENDIENTE',
    notas_cliente: '',
    notas_conductor: '',
    notas_clinica: '',
    notas_fijas: '',
};

  const [formData, setFormData] = useState({
    id_cliente: '',
    id_paciente: '',
    id_config: '',
    id_sucursal: '',
    fecha_servicio: dayjs().format('YYYY-MM-DD'),
    hora_recogida_aprox: '',
    hora_entrega_aprox: '',
    hoja_servicio: '',
    servicio_realizado: '',
    modificaciones: '',
    etiquetas: '',
    estado_transporte: 'PENDIENTE',
    numero_factura: '',
    fecha_factura: null,
    estado_factura: 'PENDIENTE',
    notas_cliente: '',
    notas_conductor: '',
    notas_clinica: '',
    notas_fijas: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

// Contador de sugerencias filtrado por sucursal actual
const cantidadSugerenciasSucursal = React.useMemo(() => {
  if (!sugerencias.length) return 0;

  // Si no hay sucursal seleccionada, mostramos el total
  if (!sucursalFiltro) {
    return sugerencias.length;
  }

  // Filtramos por id_sucursal (asumiendo que cada sugerencia tiene este campo)
  const filtradas = sugerencias.filter(sug => 
    String(sug.id_sucursal) === String(sucursalFiltro)
  );

  return filtradas.length;
}, [sugerencias, sucursalFiltro]);
  
  // Decodificar token
  useEffect(() => {
    console.log('[LogisticaDomicilio] Iniciando decodificación de token...');
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log('[LogisticaDomicilio] Payload:', payload);
        
      } catch (err) {
        console.error('[LogisticaDomicilio] Error decodificando token:', err);
        setError('Error al leer sesión');
        setSnackbarMessage('Error al leer sesión');
        setSnackbarOpen(true);
      }
    } else {
      console.warn('[LogisticaDomicilio] No hay token');
      setError('Inicia sesión primero');
      setSnackbarMessage('Por favor inicia sesión');
      setSnackbarOpen(true);
    }
  }, []);

  // Cargar datos iniciales

  
     const fetchData = React.useCallback(async () => {
    setLoading(true);
    try {
      let url = '/logistica_domicilio/?';
      if (fechaFiltro) url += `fecha=${fechaFiltro.format('YYYY-MM-DD')}&`;
      if (estadoFiltro) url += `estado=${estadoFiltro}&`;
      if (sucursalFiltro) url += `id_sucursal=${sucursalFiltro}&`;
      

      const resDomicilios = await api.get(url);
      const resClientes = await api.get('/clientes/');
      const resSucursales = await api.get('/sucursales/');

      const clienteMapTemp = resClientes.data.reduce((map, c) => {
        map[c.id_cliente] = c.nombre_cliente || `Cliente ID ${c.id_cliente}`;
        return map;
      }, {});

      setClienteMap(clienteMapTemp);
      setClientes(resClientes.data);
      setSucursales(resSucursales.data);
      setDomicilios(resDomicilios.data);
      setOriginalDomicilios(resDomicilios.data);
      setError(null);
    } catch (err) {
      console.error('[LogisticaDomicilio] Error cargando datos:', err);
      setError('Error al cargar domicilios');
      setSnackbarMessage('Error al cargar domicilios');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  }, [fechaFiltro, estadoFiltro, sucursalFiltro]);
    // Cargar datos cuando cambian los filtros
      useEffect(() => {
        fetchData();
      }, [fetchData]);   // ← Solo dejamos fetchData

  useEffect(() => {
  api.get('/razas/').then(res => {
    console.log('[Logistica] Razas cargadas:', res.data.length);
    setRazas(res.data);
  }).catch(err => console.error('[Logistica] Error cargando razas:', err));
}, []);

useEffect(() => {
    const fetchSugerencias = async () => {
        try {
            const resSug = await api.get('/logistica_domicilio/sugerencias-proximas');
              setSugerencias(resSug.data);
        } catch (err) { console.error("Error cargando sugerencias", err); }
    };
    fetchSugerencias();
}, []);

  // Búsqueda de clientes con debounce eliminated yo
  

  // Cargar pacientes cuando cambia el cliente
  useEffect(() => {
    if (formData.id_cliente && openModal) {
      console.log('[Logistica] Cargando pacientes para cliente:', formData.id_cliente);
      fetchPacientes(formData.id_cliente);
      fetchConfigForCliente(formData.id_cliente); // también precarga recurrente
    } else {
      setPacientesCliente([]);
      setEsRecurrente(false);
    }
  }, [formData.id_cliente, openModal]);

  const handleOpenWaze = (dom) => {
  // 1. Buscamos al cliente completo en la lista de 'clientes' cargada en el estado
  const clienteData = clientes.find(c => c.id_cliente === dom.id_cliente);
  
  // 2. Extraemos las coordenadas directamente del objeto cliente encontrado
  const lat = clienteData?.latitud;
  const lon = clienteData?.longitud;

  console.log(`Buscando coordenadas para cliente ${dom.id_cliente}:`, { lat, lon });

  if (lat && lon) {
    // Generar enlace de Waze con navegación activa
    const url = `https://www.waze.com/ul?ll=${lat},${lon}&navigate=yes`;
    window.open(url, '_blank');
  } else {
    setSnackbarMessage('El cliente no tiene coordenadas registradas en su ficha');
    setSnackbarOpen(true);
  }
};

  const fetchPacientes = async (id_cliente) => {
    try {
      const res = await api.get(`/pacientes/por-cliente/${id_cliente}`);
      console.log('[Logistica] Pacientes recibidos:', res.data.length);
      const pacientesFiltrados = res.data.filter(p => p.habilitado === true && p.es_fallecido !== true );  // filtra los fallecidos y deshabilitados
      setPacientesCliente(pacientesFiltrados);
    } catch (err) {
      console.error('[Logistica] Error cargando pacientes:', err);
      setSnackbarMessage('Error al cargar mascotas del cliente');
      setSnackbarOpen(true);
      setPacientesCliente([]);
    }
  };


  // 3. Función para "Agendar"
const handleAgendarSugerencia = (sug) => {
    // 1. Buscamos el objeto cliente completo en tu estado local
    const clienteEncontrado = clientes.find(c => c.nombre_cliente === sug.nombre_cliente);
    
    if (clienteEncontrado) {
        // 2. Seteamos el formData con los datos básicos
        setFormData({
            ...initialFormData,
            id_cliente: clienteEncontrado.id_cliente,
            id_sucursal: clienteEncontrado.id_sucursal,
            hoja_servicio: sug.hoja_servicio_fija || '',
            id_config: sug.id_config, // Importante para que el trigger sepa qué actualizar
            fecha_servicio: dayjs().format('YYYY-MM-DD'),
            notas_fijas: sug.notas_fijas || '',
        });

        // 3. ¡ESTA ES LA CLAVE! 
        // Creamos un objeto "ficticio" para que el modal sepa qué nombre mostrar en el encabezado
        setSelectedDomicilio({
            id_cliente: clienteEncontrado.id_cliente,
            nombre_cliente: clienteEncontrado.nombre_cliente, // Inyectamos el nombre directamente
            es_nuevo_desde_sugerencia: true 
        });

        setOpenModal(true);
    } else {
        setSnackbarMessage("Error: No se encontró el ID del cliente en la lista local.");
        setSnackbarOpen(true);
    }
};

  const fetchConfigForCliente = async (id_cliente) => {
  console.log('[Logistica] Buscando config recurrente para cliente:', id_cliente);
  try {
    const res = await api.get(`/configuracion_domicilio/?id_cliente=${id_cliente}&activo=True`);

    if (res.data.length > 0) {
      const config = res.data[0];
      setFormData(prev => ({
        ...prev,
        // PRIORIDAD: 
        // 1. Si ya tiene texto (porque estamos editando), dejamos el texto que tiene.
        // 2. Si está vacío, le ponemos lo de la config recurrente.
        hoja_servicio: prev.hoja_servicio || config.hoja_servicio_fija || '',
        etiquetas: prev.etiquetas || config.etiquetas_fijas || '',
        id_config: config.id_config,
      }));
      setEsRecurrente(true);
    } else {
      // SI NO ES RECURRENTE:
      // Solo limpiamos si el campo está vacío. 
      // Si tiene algo (porque es una edición), NO tocamos el formData.
      setFormData(prev => ({
        ...prev,
        hoja_servicio: prev.hoja_servicio || '', 
        id_config: null,
        etiquetas: prev.etiquetas || '',
      }));
      setEsRecurrente(false);
    }
  } catch (err) {
    console.error('[Logistica] Error fetching config:', err);
    setEsRecurrente(false);
  }
};

const handlePosponerSugerencia = async (sug) => {
  // Verificación de seguridad en consola
  console.log("Objeto sugerencia recibido:", sug);

  if (!sug || !sug.id_config) {
    console.error("Error: id_config no encontrado en el objeto", sug);
    setSnackbarMessage("Error: No se pudo identificar la configuración");
    setSnackbarOpen(true);
    return;
  }

  const dias = window.prompt("¿Cuántos días quieres posponer esta sugerencia? (Ej: 3)");
  
  if (dias && !isNaN(dias)) {
    const fechaPosponer = dayjs().add(parseInt(dias), 'day').format('YYYY-MM-DD');
    
    // Solo enviamos lo que queremos cambiar
    // Como ya usas ConfiguracionDomicilioUpdate en el backend, esto funcionará
    const payload = {
      posponer_hasta: fechaPosponer
    };

    try {
      console.log(`Enviando PUT a /configuracion_domicilio/${sug.id_config}`);
      
      //const res = await api.put(`/configuracion_domicilio/${sug.id_config}`, payload);
      await api.put(`/configuracion_domicilio/${sug.id_config}`, payload);
      
      setSnackbarMessage(`Sugerencia pospuesta hasta el ${dayjs(fechaPosponer).format('DD-MM-YYYY')}`);
      setSnackbarOpen(true);
      
      // Actualizar la lista local de sugerencias
      setSugerencias(prev => prev.filter(s => s.id_config !== sug.id_config));
      
    } catch (err) {
      console.error("Error detallado del servidor:", err.response?.data);
      setSnackbarMessage("Error al procesar la postergación");
      setSnackbarOpen(true);
    }
  }
};
  // Búsqueda local
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setDomicilios(originalDomicilios);
    } else {
      const term = searchTerm.toLowerCase();
      const filtered = originalDomicilios.filter(d =>
        (clienteMap[d.id_cliente]?.toLowerCase()?.includes(term) ||
         d.hoja_servicio?.toLowerCase()?.includes(term) ||
         d.estado_transporte?.toLowerCase()?.includes(term))
      );
      setDomicilios(filtered);
    }
  }, [searchTerm, originalDomicilios, clienteMap]);

const handleOpenModal = (dom = null) => {
  console.log('[LogisticaDomicilio] Abrir modal - Domicilio:', dom);

  // 1. Buscamos el nombre del cliente en nuestro mapa local usando el ID
  const nombreCliente = dom ? (clienteMap[dom.id_cliente] || `Cliente #${dom.id_cliente}`) : '';

  // 2. Inyectamos el nombre al objeto seleccionado para que el modal lo "vea"
  const domConNombre = dom ? { ...dom, nombre_cliente: nombreCliente } : null;
  setSelectedDomicilio(domConNombre);

  setFormData({
    id_cliente: dom ? dom.id_cliente : '',
    id_paciente: dom ? dom.id_paciente || '' : '',
    id_config: dom ? dom.id_config || '' : '',
    id_sucursal: dom ? dom.id_sucursal || '' : '',
    fecha_servicio: dom ? dayjs(dom.fecha_servicio).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
    hora_recogida_aprox: dom ? dom.hora_recogida_aprox || '' : '',
    hora_entrega_aprox: dom ? dom.hora_entrega_aprox || '' : '',
    hoja_servicio: dom ? dom.hoja_servicio || '' : '',
    servicio_realizado: dom ? dom.servicio_realizado || '' : '',
    modificaciones: dom ? dom.modificaciones || '' : '',
    etiquetas: dom ? dom.etiquetas || '' : '',
    estado_transporte: dom ? dom.estado_transporte : 'PENDIENTE',
    numero_factura: dom ? dom.numero_factura || '' : '',
    fecha_factura: dom ? dom.fecha_factura ? dayjs(dom.fecha_factura).format('YYYY-MM-DD') : null : null,
    estado_factura: dom ? dom.estado_factura : 'PENDIENTE',
    notas_cliente: dom ? dom.notas_cliente || '' : '',
    notas_conductor: dom ? dom.notas_conductor || '' : '',
    notas_clinica: dom ? dom.notas_clinica || '' : '',
    notas_fijas: dom ? dom.notas_fijas || '' : '',
  });

  setOpenModal(true);

  // Foco automático en hoja de servicio
  setTimeout(() => {
    const hojaInput = document.querySelector('textarea[name="hoja_servicio"]');
    if (hojaInput && !esRecurrente) {
      hojaInput.focus();
    }
  }, 300);
};
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedDomicilio(null);
    setEsRecurrente(false);
    setPacientesCliente([]);
  };

  const handleSave = async () => {
    console.log('[LogisticaDomicilio] Guardando - Datos:', formData);

    // 1. Saneamiento de datos (Asegurar enteros para el Backend)
    const dataToSend = {
      ...formData,
      id_paciente: formData.id_paciente ? Number(formData.id_paciente) : null,
      id_sucursal: formData.id_sucursal ? Number(formData.id_sucursal) : null,
      id_cliente: formData.id_cliente ? Number(formData.id_cliente) : null,
      id_config: formData.id_config && !isNaN(Number(formData.id_config)) ? Number(formData.id_config) : null,
      hora_recogida_aprox: formData.hora_recogida_aprox?.trim() || null,
      hora_entrega_aprox: formData.hora_entrega_aprox?.trim() || null,
      hoja_servicio: formData.hoja_servicio?.trim() || '',
    };

    // 2. Validaciones previas
    if (!dataToSend.id_cliente) {
      setSnackbarMessage('Seleccione un cliente');
      setSnackbarOpen(true);
      return;
    }

    if (!dataToSend.id_paciente) {
      setSnackbarMessage('Debe seleccionar un Paciente / Mascota para agendar');
      setSnackbarOpen(true);
      return; // Detiene el proceso de guardado
    }


    if (!esRecurrente && !dataToSend.hoja_servicio) {
      setSnackbarMessage('Ingrese la hoja de servicio para clientes no recurrentes');
      setSnackbarOpen(true);
      return;
    }

    setLoading(true);
    try {
      let response;
      const esEdicion = selectedDomicilio && selectedDomicilio.id_logistica;

      // 3. Petición al Servidor
      if (esEdicion) {
        console.log(`[Logistica] Realizando UPDATE al ID: ${selectedDomicilio.id_logistica}`);
        response = await api.put(`/logistica_domicilio/${selectedDomicilio.id_logistica}`, dataToSend);
      } else {
        console.log('[Logistica] Realizando CREATE (Registro nuevo)');
        response = await api.post('/logistica_domicilio/', dataToSend);
      }

      // 4. Actualización de la tabla principal de domicilios
      const updated = esEdicion
        ? originalDomicilios.map(d => d.id_logistica === selectedDomicilio.id_logistica ? response.data : d)
        : [...originalDomicilios, response.data];

      setOriginalDomicilios(updated);
      setDomicilios(updated);

      // 5. LÓGICA DE SUGERENCIAS: Quitar de la lista local inmediatamente
      if (!esEdicion && formData.id_config) {
        const idConfigTarget = Number(formData.id_config);
        setSugerencias(prevSugerencias => 
          prevSugerencias.filter(sug => Number(sug.id_config) !== idConfigTarget)
        );
        console.log(`[Logistica] Sugerencia ${idConfigTarget} removida de la vista local.`);
      }

      // 6. Feedback y cierre
      setSnackbarMessage(esEdicion ? 'Actualizado correctamente' : '¡Agendado! Se quitó de las sugerencias.');
      setSnackbarOpen(true);
      handleCloseModal();

      // 7. Sincronización opcional con el servidor (con delay para evitar caché)
      if (selectedDomicilio?.es_nuevo_desde_sugerencia || (!esEdicion && formData.id_config)) {
        setTimeout(async () => {
          try {
            const resSug = await api.get('/logistica_domicilio/sugerencias-proximas');
            setSugerencias(resSug.data);
          } catch (err) {
            console.error('[Logistica] Error al refrescar sugerencias del servidor:', err);
          }
        }, 800); 
      }
      

    } catch (err) {
      console.error('[LogisticaDomicilio] ERROR:', err);
      let mensaje = 'Error al guardar domicilio';
      if (err.response?.data?.detail) {
        mensaje = typeof err.response.data.detail === 'string' 
          ? err.response.data.detail 
          : JSON.stringify(err.response.data.detail);
      }
      setSnackbarMessage(mensaje);
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id_logistica) => {
    if (!window.confirm('¿Eliminar este domicilio?')) return;
    setLoading(true);
    try {
      await api.delete(`/logistica_domicilio/${id_logistica}`);
      const updated = originalDomicilios.filter(d => d.id_logistica !== id_logistica);
      setOriginalDomicilios(updated);
      setDomicilios(updated);

      setSnackbarMessage('Domicilio eliminado');
      setSnackbarOpen(true);
    } catch (err) {
      setSnackbarMessage('Error al eliminar');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

 const handleChangeEstado = async (id_logistica, nuevoEstado) => {
  try {
    const payload = { estado_transporte: nuevoEstado };
    console.log('[Logistica] Enviando PUT parcial:', payload);
    //error original de no uso const res = await api.put(`/logistica_domicilio/${id_logistica}`, payload);
    // sugerida pero mismo resultado const response = await api.put(`/logistica_domicilio/${id_logistica}`, payload);
    await api.put(`/logistica_domicilio/${id_logistica}`, payload);
    // actualizar lista local
    const updated = domicilios.map(d =>
      d.id_logistica === id_logistica ? { ...d, estado_transporte: nuevoEstado } : d
    );
    setDomicilios(updated);
    setOriginalDomicilios(originalDomicilios.map(d =>
      d.id_logistica === id_logistica ? { ...d, estado_transporte: nuevoEstado } : d
    ));
    setSnackbarMessage('Estado actualizado');
    setSnackbarOpen(true);
  } catch (err) {
    console.error('[Logistica] Error cambiando estado:', err.response?.data);
    setSnackbarMessage(err.response?.data?.detail || 'Error al cambiar estado');
    setSnackbarOpen(true);
  }
};

  const handleSnackbarClose = () => setSnackbarOpen(false);

  if (loading && !domicilios.length) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Logística de Domicilios
          </Typography>
        </Toolbar>
      </AppBar>
 {/* + NUEVODOMICILIO BOTON Y TITULO*/}
      <Container maxWidth="xl" sx={{ mt: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/clientes')} sx={{ mr: 2 }}>
            Regresar
          </Button>
          <Typography variant="h4">Domicilios del Día</Typography>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenModal()}>
            NUEVO DOMICILIO
          </Button>
        </Box>
        {/* NUEVO: PANEL DE SUGERENCIAS */}
<Accordion sx={{ mb: 4, bgcolor: '#f9f9f9', border: '1px solid #e0e0e0' }}>
  <AccordionSummary expandMoreIcon={<ExpandMoreIcon />}>
    <Typography variant="h6" sx={{ color: 'primary.main', display: 'flex', alignItems: 'center', gap: 1 }}>
  <EventNoteIcon /> 
  Sugerencias de Próximas Visitas 
  <Box
    component="span"
    sx={{
      bgcolor: 'primary.main',
      color: 'white',
      px: 1.2,
      py: 0.3,
      borderRadius: '12px',
      fontSize: '0.8rem',
      fontWeight: 'bold',
      minWidth: 24,
      textAlign: 'center',
      display: 'inline-block'
    }}
  >
    {cantidadSugerenciasSucursal}
  </Box>
</Typography>
  </AccordionSummary>
  <AccordionDetails>
    {sugerencias.length === 0 ? (
      <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
        No hay visitas sugeridas para los próximos días.
      </Typography>
    ) : (
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead sx={{ bgcolor: '#f0f0f0' }}>
            <TableRow>
              <TableCell><strong>Cliente</strong></TableCell>
              <TableCell><strong>Frecuencia</strong></TableCell>
              <TableCell><strong>Última Visita</strong></TableCell>
              <TableCell><strong>Fecha Sugerida</strong></TableCell>
              <TableCell><strong>Notas Fijas</strong></TableCell>
              <TableCell align="right"><strong>Acción</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
  {sugerencias
    /* 1. Aplicamos el filtro antes de mapear */
    .filter((sug) => {
      // Si no hay filtro seleccionado, mostramos todas
      if (!sucursalFiltro) return true;
      // Comparamos el id_sucursal de la vista con el filtro (convertidos a número)
      return Number(sug.id_sucursal) === Number(sucursalFiltro);
    })
    /* 2. Mapeamos los resultados filtrados */
    .map((sug) => (
      <TableRow key={sug.id_config} hover>
        <TableCell> 
          <Button 
            size="small" 
            color="primary" 
            sx={{ textTransform: 'none', fontWeight: 'bold' }} 
            endIcon={<OpenInNewIcon sx={{ fontSize: 12 }} />} 
            onClick={() => {
              const clienteParaLink = clientes.find(c => c.nombre_cliente === sug.nombre_cliente); 
              if (clienteParaLink) { 
                window.open(`/clientes/${clienteParaLink.id_cliente}`, '_blank'); 
              } else { 
                setSnackbarMessage("No se encontró la ficha del cliente"); 
                setSnackbarOpen(true); 
              } 
            }} 
          > 
            {sug.nombre_cliente} 
          </Button> 
        </TableCell>
        <TableCell>{sug.frecuencia}</TableCell>
        <TableCell> 
          <Typography variant="body2" sx={{ color: 'text.secondary' }}> 
            {sug.ultima_visita_realizada ? dayjs(sug.ultima_visita_realizada).format('DD-MM-YYYY') : 'Sin registro'} 
          </Typography> 
        </TableCell>
        
        <TableCell>
          <Typography variant="body2" sx={{ 
            fontWeight: 'bold', 
            color: dayjs(sug.fecha_sugerida).isBefore(dayjs()) ? 'error.main' : 'warning.main' 
          }}>
            {dayjs(sug.fecha_sugerida).format('DD/MM/YYYY')}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography 
            variant="caption" 
            sx={{ 
              color: 'text.secondary',
              fontStyle: 'italic',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }} 
            title={sug.notas_fijas}
          >
            {sug.notas_fijas || 'Sin notas especiales'}
          </Typography>
        </TableCell>

        <TableCell align="right">
  <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
    {/* Verificamos si el id_config ya existe en la lista de domicilios */}
    {domicilios.some(dom => Number(dom.id_config) === Number(sug.id_config)) ? (
      /* ESCENARIO A: YA ESTÁ AGENDADO
         Mostramos solo el indicador y ocultamos ambos botones (Agendar y Posponer) 
      */
      <Typography 
        variant="caption" 
        sx={{ 
          bgcolor: '#e8f5e9', 
          color: '#2e7d32', 
          px: 1.5, 
          py: 0.5, 
          borderRadius: '4px', 
          fontWeight: 'bold',
          border: '1px solid #2e7d32'
        }}
      >
        YA EN AGENDA PARA RUTA
      </Typography>
    ) : (
      /* ESCENARIO B: NO ESTÁ AGENDADO
         Mostramos los botones de acción normales
      */
      <>
        <Button 
          variant="contained" 
          size="small" 
          startIcon={<AddIcon />}
          onClick={() => handleAgendarSugerencia(sug)}
        >
          Agendar
        </Button>
        
        <IconButton 
          size="small" 
          color="warning" 
          title="Posponer sugerencia"
          onClick={() => handlePosponerSugerencia(sug)} 
        >
          <UpdateIcon fontSize="small" />
        </IconButton>
      </>
    )}
  </Box>
</TableCell>
      </TableRow>
    ))}
</TableBody>
        </Table>
      </TableContainer>
    )}
  </AccordionDetails>
</Accordion>

        <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Fecha"
              value={fechaFiltro}
              onChange={(newValue) => setFechaFiltro(newValue)}
              slotProps={{ textField: { sx: { width: 200 } } }}
            />
          </LocalizationProvider>

          <FormControl sx={{ minWidth: 160 }}>
            <InputLabel>Estado</InputLabel>
            <Select
              value={estadoFiltro}
              label="Estado"
              onChange={(e) => setEstadoFiltro(e.target.value)}
            >
              <MenuItem value="">Todos</MenuItem>
              {ESTADOS_TRANSPORTE.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 160 }}>
            <InputLabel>Sucursal</InputLabel>
            <Select
              value={sucursalFiltro}
              label="Sucursal"
              onChange={(e) => setSucursalFiltro(e.target.value)}
            >
              <MenuItem value="">Todas</MenuItem>
              {sucursales.map(s => (
                <MenuItem key={s.id_sucursal} value={s.id_sucursal}>{s.nombre_sucursal}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            sx={{ flexGrow: 1 }}
            variant="outlined"
            placeholder="Buscar por cliente o servicio..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            }}
          />
        </Box>

        {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Fecha</TableCell>
                <TableCell>Cliente</TableCell>
                <TableCell>Paciente</TableCell>
                <TableCell>Servicio</TableCell>
                <TableCell>Estado Transporte</TableCell>
                <TableCell>Factura N°</TableCell>
                <TableCell align="right">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
  {domicilios.map((dom) => (
    <TableRow key={dom.id_logistica} hover>
      <TableCell sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
        #{dom.id_logistica}
      </TableCell>
      
      <TableCell>
        {dayjs(dom.fecha_servicio).format('DD/MM/YYYY')}
      </TableCell>

      {/* COLUMNA CLIENTE: Acceso directo al objeto anidado */}
      <TableCell>
  <Box 
    sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      cursor: 'pointer' 
    }}
    onClick={(e) => {
      e.stopPropagation(); // Evita que se abra el modal de la fila
      const id = dom.id_cliente || dom.paciente?.cliente?.id_cliente;
      if (id) {
        window.open(`/clientes/${id}`, '_blank');
      }
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography
        variant="body2"
        sx={{
          color: 'primary.main',
          fontWeight: 'bold',
          '&:hover': { textDecoration: 'underline' }
        }}
      >
        {dom.paciente?.cliente?.nombre_cliente || 'Sin nombre'}
      </Typography>
      
      {!dom.id_config && (
        <BusAlertIcon sx={{ fontSize: 16, color: 'warning.main' }} titleAccess="Cliente Foraneo" />
      )}
      <OpenInNewIcon sx={{ fontSize: 14, color: 'primary.main', opacity: 0.8 }} />
    </Box>

    <Typography variant="caption" color="text.secondary">
      {dom.paciente?.cliente?.direccion_cliente || 'Sin dirección registrada'}
    </Typography>
  </Box>
</TableCell>

      {/* COLUMNA PACIENTE */}
            
      <TableCell>
        <Box display="flex" alignItems="center" gap={1}>
          <PetsIcon sx={{ fontSize: 16, color: 'action.active' }} />
          <Box>
            <Typography variant="body2" fontWeight="medium">
              {dom.paciente?.nombre_paciente || 'Desconocido'}
            </Typography>
            {/* Nueva línea con la raza */}
            <Typography variant="caption" color="text.secondary">
              {dom.paciente?.nombre_raza || 'Raza no registrada'}
            </Typography>
          </Box>
        </Box>
      </TableCell>

      <TableCell>
        <Typography variant="body2" sx={{ fontStyle: dom.hoja_servicio ? 'normal' : 'italic' }}>
          {dom.hoja_servicio ? (dom.hoja_servicio.substring(0, 40) + (dom.hoja_servicio.length > 40 ? '...' : '')) : 'Sin descripción'}
        </Typography>
      </TableCell>

      <TableCell>
        <FormControl size="small" fullWidth sx={{ minWidth: 120 }}>
          <Select
            value={dom.estado_transporte || 'PENDIENTE'}
            onChange={(e) => handleChangeEstado(dom.id_logistica, e.target.value)}
            disabled={false} 
            sx={{ 
              fontSize: '0.8125rem',
              borderRadius: '8px',
              bgcolor: dom.estado_transporte === 'ENTREGADO' ? '#e8f5e9' : 'transparent'
            }}
          >
            {ESTADOS_TRANSPORTE.map((e) => (
              <MenuItem key={e} value={e} sx={{ fontSize: '0.8125rem' }}>
                {e.replace(/_/g, ' ')}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </TableCell>

      <TableCell>
        <Chip 
          label={dom.numero_factura || 'PEND.'} 
          size="small" 
          variant="outlined"
          color={dom.numero_factura ? "success" : "default"}
        />
      </TableCell>

      <TableCell align="right">
        <Box display="flex" justifyContent="flex-end">
          <IconButton
            color="primary"
            onClick={() => handleOpenWaze(dom)}
            title="Navegar con Waze"
            size="small"
          >
            <DirectionsIcon />
          </IconButton>

          <IconButton 
            onClick={() => handleOpenModal(dom)} 
            color="inherit"
            size="small"
          >
            <EditIcon fontSize="small" />
          </IconButton>

          <IconButton
            color="error"
            onClick={() => handleDelete(dom.id_logistica)}
            size="small"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </TableRow>
  ))}
</TableBody>
          </Table>
        </TableContainer>

     <LogisticaDomicilioModal 
  open={openModal} 
  onClose={handleCloseModal} 
  selectedDomicilio={selectedDomicilio} 
  formData={formData} 
  setFormData={setFormData} 
  clientes={clientes} 
  pacientesCliente={pacientesCliente} 
  sucursales={sucursales} 
  esRecurrente={esRecurrente} 
  handleSave={handleSave} 
  razas={razas}
/>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert 
            onClose={handleSnackbarClose} 
            severity={snackbarMessage.includes('Error') ? 'error' : 'success'}
          >
            {typeof snackbarMessage === 'string' ? snackbarMessage : 'Error inesperado'}
          </Alert>
        </Snackbar>
      </Container>
    </Box>
  );
};

export default LogisticaDomicilio;